module.exports = __webpack_public_path__ + "img/shopping.4c100a8d.png";